module.exports = __webpack_public_path__ + "img/xingye.a00f7b68.svg";